import { fabric } from 'fabric';
import { YCanvas } from './../fabric-utils';

export type TextStyleDeclaration = Record<string, any>;

// return true if state has changed
export function updateMixedFontSizesState(textbox: fabric.Textbox): boolean {
  const oldHasMixedSizes = (textbox as any).hasMixedSizes ?? false;

  const hasMixedSizes = Boolean(
    textbox.styles &&
      Object.values(textbox.styles).some(
        (line: any) =>
          line &&
          Object.values(line).some(
            (charStyle: any) =>
              charStyle?.fontSize !== undefined && charStyle.fontSize !== textbox.fontSize,
          ),
      ),
  );

  (textbox as any).hasMixedSizes = hasMixedSizes;
  return oldHasMixedSizes !== hasMixedSizes;
}

export function cleanAllStyles(textbox: fabric.Textbox) {
  if (!textbox || !textbox.styles || textbox.text?.length === 0) {
    return;
  }
  // skip clean styles for empty textboxes
  if (YCanvas.isEmptyTextbox(textbox)) {
    return;
  }
  const styleProperties = (textbox as any)._styleProperties || [];
  styleProperties.forEach((styleProperty: string) => {
    textbox.cleanStyle(styleProperty);
  });
}
